import { render, staticRenderFns } from "./instanceNode.vue?vue&type=template&id=6f28004e&scoped=true"
import script from "./instanceNode.vue?vue&type=script&lang=js"
export * from "./instanceNode.vue?vue&type=script&lang=js"
import style0 from "./instanceNode.vue?vue&type=style&index=0&id=6f28004e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28004e",
  null
  
)

export default component.exports